<script setup></script>

<template>
  <div>
    <RouterView />
    <RiseToast v-model="$toastItems" />
    <RiseGradients />
  </div>
</template>
